import { StarIcon } from 'lucide-react';

import { Testimonial } from '@/slw/entities/dealer/sell-your-car/sell-your-car.type';
import { Skeleton } from '@/slw/shared/ui/skeleton';

import { TestimonialCard } from './testimonials-card.ui';

export function TestimonialsSection({ testimonials, isLoading }: { testimonials: Testimonial[]; isLoading: boolean }) {
  const renderLoading = () => {
    return [1, 2, 3].map((i) => (
      <div key={i} className='flex items-start space-x-2.5'>
        <Skeleton className='w-10 h-10 rounded-full' />
        <div className='space-y-2'>
          <Skeleton className='h-4 w-24' />
          <Skeleton className='h-16 w-full' />
        </div>
      </div>
    ));
  };

  const renderSection = () => {
    return testimonials.map((testimonial, index) => (
      <TestimonialCard key={index} name={testimonial.name} text={testimonial.text} avatar={testimonial.avatar} />
    ));
  };

  return (
    <div className='space-y-12'>
      <div className=''>
        <h2 className='text-2xl font-bold leading-[150%] mb-2.5'>Trusted by Hundreds of Thousands of Sellers</h2>
        <p className='text-sm font-medium leading-[150%]'>
          What Buyers and Sellers are saying about ClovisClassics.com
        </p>
      </div>
      <div className='flex sm:flex-row flex-col gap-6 items-center'>
        <div className='space-y-2 flex flex-col items-center'>
          <div className='flex items-center justify-center space-x-1'>
            {[1, 2, 3, 4, 5].map((star) => {
              if (star <= 4) {
                return <StarIcon key={star} size={16} className='text-[#FF9500]' fill='currentColor' />;
              }

              if (star === 5) {
                return (
                  <span key={star} className='relative inline-block' style={{ width: 16, height: 16 }}>
                    <StarIcon size={16} className='text-gray-300 absolute left-0 top-0' fill='currentColor' />
                    <StarIcon
                      size={16}
                      className='text-[#FF9500] absolute left-0 top-0'
                      fill='currentColor'
                      style={{ clipPath: 'inset(0 50% 0 0)' }}
                    />
                  </span>
                );
              }
            })}
          </div>
          <h3 className='text-xl font-semibold leading-[150%] whitespace-nowrap '>Average: 4.5</h3>
          <span className='text-xs text-muted-foreground leading-[140%] whitespace-nowrap '>
            Based on 10,000 reviewers
          </span>
        </div>
        <div className='space-y-2.5 bg-[#F8F8F7] rounded-md p-4'>{isLoading ? renderLoading() : renderSection()}</div>
      </div>
    </div>
  );
}
